/* cb-wishlist.js - filteren, sorteren en alles-in-de-wagen op de verlanglijst
 *
 * Hoort bij sections/cb-wishlist.liquid. Wat dit script NIET doet: de lijst
 * bijhouden. Dat is het werk van custom.js en van de EcomRise-app; zie de
 * comment-kop van de sectie. Hier wordt alleen gewerkt met wat er al op de
 * pagina staat.
 *
 * Elke kaart is herkenbaar aan de hdt-wishlist-knop erin: die draagt het
 * product-id. De rest (type, prijs, voorraad, variant) staat in het JSON-blok
 * dat de sectie meegeeft. Zo hoeft de kaart zelf niet aangepast te worden en
 * blijft hij gelijk aan die op de collectie- en zoekpagina.
 */
(function () {
  var root = document.querySelector('[data-cb-wishlist]');
  if (!root) { return; }

  var grid = root.querySelector('[data-cb-grid]');
  if (!grid) { return; }

  var dataNode = root.querySelector('[data-cb-wishlist-data]');
  var meta = {};
  try { meta = JSON.parse(dataNode.textContent); } catch (error) { meta = {}; }

  var none = root.querySelector('[data-cb-none]');
  var chipCount = root.querySelector('[data-cb-chip-count]');
  var bulkBar = root.querySelector('[data-cb-bulkbar]');
  var bulkCount = root.querySelector('[data-cb-bulk-count]');
  var bulkTotal = root.querySelector('[data-cb-bulk-total]');

  /* De volgorde waarin de items bewaard zijn staat in dezelfde opslag die
     custom.js gebruikt: nieuwste vooraan. Voor ingelogde klanten vult de
     EcomRise-app #hdt_wishlist_list. Is er geen van beide, dan blijft de
     volgorde staan zoals de server hem gaf. */
  function savedOrder() {
    var app = document.getElementById('hdt_wishlist_list');
    if (app && app.textContent.trim()) { return app.textContent.trim().split(' '); }
    try {
      var stored = localStorage.getItem(root.getAttribute('data-storage-key'));
      return stored ? stored.split(',') : [];
    } catch (error) {
      return [];
    }
  }
  var order = savedOrder();

  var cards = Array.prototype.slice.call(grid.children).map(function (el) {
    var button = el.querySelector('hdt-wishlist[data-id]');
    var id = button ? button.getAttribute('data-id') : '';
    var info = meta[id] || {};
    var position = order.indexOf(id);
    return {
      el: el,
      id: id,
      type: (info.type || '').toUpperCase(),
      price: typeof info.price === 'number' ? info.price : 0,
      available: info.available === true,
      variant: info.variant || 0,
      /* Niet in de opslag gevonden: achteraan, maar wel in de oorspronkelijke
         volgorde onderling. */
      position: position === -1 ? 9999 : position
    };
  });

  var state = { filter: 'all', sort: 'recent' };

  function matches(card) {
    if (state.filter === 'all') { return true; }
    if (state.filter === 'gone') { return !card.available; }
    return card.type === state.filter;
  }

  function compare(a, b) {
    if (state.sort === 'low') { return a.price - b.price; }
    if (state.sort === 'high') { return b.price - a.price; }
    if (state.sort === 'stock') {
      if (a.available !== b.available) { return a.available ? -1 : 1; }
      return a.position - b.position;
    }
    return a.position - b.position;
  }

  /* Bedragen via het money_format van de winkel, nooit via Intl: de winkel
     schrijft EUR 5,50 in beide talen en Intl zou dat per locale anders doen.
     Shopify groepeert in al zijn varianten per drie cijfers, dus dat gebeurt
     hier ook; alleen de scheidingstekens verschillen per variant. */
  function money(cents) {
    var format = root.getAttribute('data-money-format') || '{{amount}}';
    var fixed = (cents / 100).toFixed(2);
    var whole = fixed.split('.')[0];
    var decimals = fixed.split('.')[1];

    function group(separator) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group('.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group('.') + ',' + decimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, group("'") + '.' + decimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(','))
      .replace(/\{\{\s*amount\s*\}\}/g, group(',') + '.' + decimals);
  }

  function render() {
    var visible = cards.filter(matches).sort(compare);

    var frag = document.createDocumentFragment();
    visible.forEach(function (card) {
      card.el.hidden = false;
      frag.appendChild(card.el);
    });
    cards.forEach(function (card) {
      if (visible.indexOf(card) === -1) { card.el.hidden = true; }
    });
    grid.appendChild(frag);

    if (none) { none.hidden = visible.length > 0; }
    if (chipCount) { chipCount.textContent = '(' + visible.length + ')'; }

    var buyable = visible.filter(function (card) { return card.available && card.variant; });
    var total = buyable.reduce(function (sum, card) { return sum + card.price; }, 0);

    if (bulkCount) {
      bulkCount.textContent = buyable.length + ' ' + root.getAttribute('data-word-available');
    }
    if (bulkTotal) { bulkTotal.textContent = money(total); }
    if (bulkBar) { bulkBar.hidden = buyable.length === 0; }

    Array.prototype.forEach.call(root.querySelectorAll('[data-cb-bulk]'), function (button) {
      button.disabled = buyable.length === 0;
    });

    return buyable;
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-filter]'), function (button) {
    button.addEventListener('click', function () {
      state.filter = button.getAttribute('data-cb-filter');
      Array.prototype.forEach.call(root.querySelectorAll('[data-cb-filter]'), function (other) {
        other.classList.toggle('is-on', other === button);
      });
      render();
    });
  });

  var sort = root.querySelector('[data-cb-sort]');
  sort && sort.addEventListener('change', function () {
    state.sort = sort.value;
    render();
  });

  /* Alles wat te koop is in een keer in de wagen. Shopify neemt een lijst in
     een keer aan, dus dat is een request en geen rij losse aanroepen. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-bulk]'), function (button) {
    button.addEventListener('click', function () {
      var buyable = cards.filter(matches).filter(function (card) {
        return card.available && card.variant;
      });
      if (buyable.length === 0) { return; }

      button.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: buyable.map(function (card) {
            return { id: card.variant, quantity: 1 };
          })
        })
      }).then(function (response) {
        if (!response.ok) { throw new Error('cart'); }
        /* De winkelwagen opnieuw laten lezen door het thema; lukt dat niet,
           dan is de gewone winkelwagenpagina de terugval. */
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      }).catch(function () {
        button.disabled = false;
        button.textContent = button.getAttribute('data-label');
      });
    });
  });

  var share = root.querySelector('[data-cb-share]');
  if (share && navigator.clipboard) {
    var shareLabel = share.textContent;
    share.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        share.textContent = root.getAttribute('data-copied-label');
        share.classList.add('is-done');
        setTimeout(function () {
          share.textContent = shareLabel;
          share.classList.remove('is-done');
        }, 1600);
      });
    });
  } else if (share) {
    share.hidden = true;
  }

  render();
})();
